/* eslint-disable complexity */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-lines-per-function */

import Autosuggest from "components/Autosuggest"
import Button from "components/buttons/Button"
import {
  FieldLabel,
  FieldLabelAndValue,
  FieldRow,
  FieldValue
} from "components/Fields/styled"
import { Actions } from "components/List/ItemView/styled"
import Typography from "components/Typography"

import { ComponentProps } from "."

const ActionsAndInfoSideBar = ({
  actionButtonLabel,
  actionButtonOnClick,
  isActionButtonLoading,
  isAdd,
  isAdmin,
  isEditMode,
  isEditor,
  isLinkedItemsSuggestionsLoading,
  item,
  linkedItemLabel,
  linkedItems,
  linkedItemsSearchInputId,
  linkedItemsSearchLabel,
  linkedItemPath,
  onGetLinkedItemsSuggestions,
  onModalConfirmOpen,
  onSelectLinkedItemId,
  outlinedButtonLabel,
  outlinedButtonOnClick,
  selectedLinkedItemId
}: ComponentProps) => (
  <Actions aria-label="Actions and Info" role="region">
    {isAdmin || isEditor ? (
      <Button
        disabled={isActionButtonLoading}
        label={outlinedButtonLabel}
        onClick={outlinedButtonOnClick}
        outlined
        type="button"
      />
    ) : null}

    {isAdmin || isEditor ? (
      <Button
        disabled={isActionButtonLoading}
        label={actionButtonLabel}
        loading={isActionButtonLoading}
        onClick={actionButtonOnClick}
        type={isEditMode ? "submit" : "button"}
      />
    ) : null}

    {isAdd ? null : isAdmin || isEditor ? (
      <Button
        disabled={isEditMode}
        label={item?.isPublished ? "Unpublish" : "Publish"}
        onClick={onModalConfirmOpen("publishConfirm")}
        outlined={item?.isPublished}
        secondary
        title={isEditMode ? "Cannot publish while editing" : ""}
        type="button"
      />
    ) : null}

    {(isAdmin || isEditor) &&
    isEditMode &&
    linkedItemsSearchLabel &&
    onGetLinkedItemsSuggestions &&
    onSelectLinkedItemId ? (
      <Autosuggest
        hasSelectedIcon
        inputId={linkedItemsSearchInputId}
        isLoading={isLinkedItemsSuggestionsLoading}
        label={linkedItemsSearchLabel}
        onGetSuggestions={onGetLinkedItemsSuggestions}
        onSuggestionClick={onSelectLinkedItemId}
        suggestions={linkedItems}
        value={selectedLinkedItemId}
      />
    ) : null}

    {item?.linkedItem && !isEditMode ? (
      <FieldLabelAndValue>
        <FieldLabel>{linkedItemLabel}</FieldLabel>

        <FieldValue>
          <Typography.Link to={`${linkedItemPath}/${item?.linkedItem.id}`}>
            {item?.linkedItem.name}
          </Typography.Link>
        </FieldValue>
      </FieldLabelAndValue>
    ) : null}

    {isAdd ? null : (
      <FieldRow>
        <FieldLabelAndValue>
          <FieldLabel>{"Created At"}</FieldLabel>

          <FieldValue>
            {item?.createdAt
              ? `${new Date(item.createdAt).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric"
                })}, ${new Date(item.createdAt).toLocaleTimeString("en-GB", {
                  hour: "2-digit",
                  minute: "2-digit"
                })}`
              : undefined}
          </FieldValue>
        </FieldLabelAndValue>

        <FieldLabelAndValue>
          <FieldLabel>{"Updated At"}</FieldLabel>

          <FieldValue>
            {item?.updatedAt
              ? `${new Date(item.updatedAt).toLocaleDateString("en-GB", {
                  day: "numeric",
                  month: "long",
                  year: "numeric"
                })}, ${new Date(item.updatedAt).toLocaleTimeString("en-GB", {
                  hour: "2-digit",
                  minute: "2-digit"
                })}`
              : undefined}
          </FieldValue>
        </FieldLabelAndValue>

        {item?.publishedAt ? (
          <FieldLabelAndValue>
            <FieldLabel>{"Published At"}</FieldLabel>

            <FieldValue>
              {item?.publishedAt
                ? `${new Date(item.publishedAt).toLocaleDateString("en-GB", {
                    day: "numeric",
                    month: "long",
                    year: "numeric"
                  })}, ${new Date(item.publishedAt).toLocaleTimeString(
                    "en-GB",
                    {
                      hour: "2-digit",
                      minute: "2-digit"
                    }
                  )}`
                : undefined}
            </FieldValue>
          </FieldLabelAndValue>
        ) : null}
      </FieldRow>
    )}
  </Actions>
)

export default ActionsAndInfoSideBar
